import React from 'react';
interface LogoProps {
  showText?: boolean;
  className?: string;
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md' | 'lg';
}
export function Logo({
  showText = true,
  className = '',
  variant = 'dark',
  size = 'md'
}: LogoProps) {
  const iconSizes = {
    sm: 24,
    md: 32,
    lg: 44
  };
  const textClasses = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-2xl'
  };
  const iconSize = iconSizes[size];
  const textColor = variant === 'light' ? 'text-white' : 'text-gray-900';
  const digitalColor = variant === 'light' ? 'text-blue-300' : 'text-blue-600';
  return <div className={`flex items-center gap-2.5 ${className}`} data-id="element-159">
      {/* Isotipo: 3 layered diamonds */}
      <svg width={iconSize} height={iconSize} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-160">
        {/* Bottom layer — lightest */}
        <rect x="8" y="20" width="16" height="16" rx="3" transform="rotate(-45 8 20)" fill="#93C5FD" data-id="element-161" />
        {/* Middle layer */}
        <rect x="12" y="16" width="16" height="16" rx="3" transform="rotate(-45 12 16)" fill="#3B82F6" data-id="element-162" />
        {/* Top layer — darkest */}
        <rect x="16" y="12" width="16" height="16" rx="3" transform="rotate(-45 16 12)" fill="#2563EB" data-id="element-163" />
      </svg>

      {/* Text */}
      {showText && <span className={`tracking-tight leading-none ${textClasses[size]}`} data-id="element-164">
          <span className={`font-bold ${textColor}`} data-id="element-165">obra</span>
          <span className={`font-bold ${digitalColor}`} data-id="element-166">digital</span>
        </span>}
    </div>;
}